import userStore from "./user/User.Store";
import contractorStore from "./contractor/Contractor.Store";
import projectStore from "./project/Project.Store";
import languageStore from "./language/Language.Store";
import contactStore from "./contact/Contact.Store";
import companyInfoStore from './companyInfo/CompanyInfo.Store';
import fieldStore from './fieldMasterData/fieldMasterData.Store';
import biddingCategoryStore from './biddingCategory/BiddingCategory.Store';
import cartOrderStore from './cartOrder/CartOrder.Store';
import masterStore from './master/Master.Store';
import participantStore from './participant/Participant.Store';
import membershipStore from './membership/Membership.Store';
import productStore from './product/Product.Store';
import notifyStore from './notify/Notify.Store';
import ratingStore from './rating/Rating.Store';
import ticketStore from './ticket/Ticket.Store';
import slideShopStore from './slideShop/SlideShop.Store';
import newsStore from './news/News.Store';
import routeStore from './RouteStore';

export default {
  userStore, 
  contractorStore, 
  languageStore, 
  projectStore, 
  contactStore,
  companyInfoStore,
  fieldStore,
  biddingCategoryStore,
  cartOrderStore,
  masterStore,
  participantStore,
  membershipStore,
  productStore,
  notifyStore,
  ratingStore,
  ticketStore,
  slideShopStore,
  newsStore,
  routeStore
};



// WEBPACK FOOTER //
// ./src/services/_store.js